var wechatJS = {
    data() {
        return {

        }
    },
    methods: {
        wechatInit(weiXinConfig) {
            let that = this;
            that.$wechat.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: weiXinConfig.appId, // 必填，公众号的唯一标识
                timestamp: weiXinConfig.timestamp, // 必填，生成签名的时间戳
                nonceStr: weiXinConfig.nonceStr, // 必填，生成签名的随机串
                signature: weiXinConfig.signature, // 必填，签名
                jsApiList: ['getNetworkType', 'hideMenuItems', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
            });
            that.$wechat.ready(function() {
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                that.$wechat.getNetworkType({
                    success: function(res) {
                        var networkType = res.networkType; // 返回网络类型2g，3g，4g，wifi
                        console.log('测试获取网络类型：' + networkType);
                    }
                });
                // 隐藏的菜单项，只能隐藏传播类和保护类菜单
                that.$wechat.hideMenuItems({
                    menuList: ["menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:qq", "menuItem:share:QZone", "menuItem:share:email"]
                });
                
                // 分享事件监听
                that.shareHandle();
            });
            that.$wechat.error(function(res) {
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                console.log('微信jssdk配置初始化失败');
                console.log(res);
            });
        },
        shareHandle(share) {
            if (this.$isWeixin()) {
                if(!share) {
                    share = {
                        title: '来邦养老商城', // 分享标题
                        desc: "实时监测长者生命安全，并可自动报警及定位；子女App可及时收到报警；若子女未及时处理，来邦24小时守护中心立即介入。采用独特防水设计，手表无需办卡，通讯免费，可待机7天，按钮/信标/探头自带电池可续航6年。", // 分享描述
                        link: sessionStorage.domainURL + '/LonBonStore', // 分享链接
                        imgUrl: sessionStorage.domainURL + '/LonBonStore/static/images/share.png' // 分享图标
                    }
                }
                this.$wechat.onMenuShareTimeline(share);
                this.$wechat.onMenuShareAppMessage(share);
            }
        }
    }
}
export default wechatJS


// WEBPACK FOOTER //
// ./src/components/common/wechat.js